import { BookingSummary, HotelDetails, DynamicLinkList } from '@/domain/BookingSummary'

export default {
  bookingDetails: BookingSummary.empty(),
  hotelDetails: HotelDetails.empty(),
  dynamicLinkList: DynamicLinkList.empty(),
  dynamicLinkLoading: false,
  bookingCheckinCheckoutInfo: {}
}
